"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsInstanceHistoryLog_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsInstanceHistoryLog_Factory = /** @class */ (function () {
    function EFormsInstanceHistoryLog_Factory() {
    }
    EFormsInstanceHistoryLog_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ActionDate: Date_Factory_1.Date_Factory.CreateIncoming(model.ActionDate),
            ActionTypeCode: model.ActionTypeCode,
            InstanceId: model.InstanceId,
            PreviousJSONBody: model.PreviousJSONBody,
            RecordId: model.RecordId,
            UserId: model.UserId,
        };
        return result;
    };
    EFormsInstanceHistoryLog_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ActionDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.ActionDate),
            ActionTypeCode: model.ActionTypeCode,
            InstanceId: model.InstanceId,
            PreviousJSONBody: model.PreviousJSONBody,
            RecordId: model.RecordId,
            UserId: model.UserId,
        };
        return result;
    };
    return EFormsInstanceHistoryLog_Factory;
}());
exports.EFormsInstanceHistoryLog_Factory = EFormsInstanceHistoryLog_Factory;
